//
//
//
//
//
//
//
//

import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData'

export default {
  components: {
    VueApexCharts,
  },
  setup() {
    return { apexChatData }
  },
}
